import { TemplateAPIType, AuthUserType } from "../../../Actions/Types"
import { Reducer } from "redux"
import {
    APIAppTemplateModel,
    TemplateName
} from "../../../Models/API/AppTemplateModel"
import { AuthAction } from "../../Auth"
import {
    mergeRecords,
    mergeErrors,
    getInitialData,
    RemoteData,
    setPagesToStale,
    setList
} from "../../../Models/Client/RemoteData"
import { RouterAction, LOCATION_CHANGE } from "connected-react-router"
import { Map } from "immutable"

export type AppTemplateState = RemoteData<APIAppTemplateModel, {}, TemplateName>

interface AppTemplateSetListAction {
    type: TemplateAPIType.setList
    payload: APIAppTemplateModel[]
}

interface AppTemplateAddTemplatesAction {
    type: TemplateAPIType.addTemplates
    payload: APIAppTemplateModel[]
}

interface AppTemplateReceiveErrorsAction {
    type: TemplateAPIType.receiveErrors
    payload: Map<TemplateName, string> // error messages
}

export type AppTemplateAction =
    | AppTemplateSetListAction
    | AppTemplateAddTemplatesAction
    | AppTemplateReceiveErrorsAction

const initialState: AppTemplateState = getInitialData()

const getId = (model: APIAppTemplateModel) => model.name

export const AppTemplateReducer: Reducer<
    AppTemplateState,
    AppTemplateAction | AuthAction | RouterAction
> = (state = initialState, action): AppTemplateState => {
    switch (action.type) {
        case LOCATION_CHANGE:
            return setPagesToStale(state, 0)
        case TemplateAPIType.setList:
            return setList(state, {}, action.payload, getId)
        case TemplateAPIType.addTemplates:
            return {
                ...state,
                records: mergeRecords(state.records, action.payload, getId)
            }
        case TemplateAPIType.receiveErrors:
            return {
                ...state,
                records: mergeErrors(state.records, action.payload)
            }
        case AuthUserType.signedIn:
            // `dpWorkflows` field in template model only exists for sysadmins,
            // so I have to invalidate data on sign-up to make sure the field gets populated
            return initialState
        case AuthUserType.signedOut:
            return initialState
        default:
            return state
    }
}
